'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getVariables = exports.getVariables = function getVariables(params) {
  return params.split('$').filter(function (part) {
    return part.split(':')[0];
  }).map(function (part) {
    return part.split(':')[0];
  });
};

var getQueryParams = exports.getQueryParams = function getQueryParams(params) {
  return params.split('$').map(function (part) {
    if (!part) return '';
    var variable = part.split(':')[0];
    return variable + ': $' + variable;
  }).join(' ');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/meteor-paginated-graphql-react/lib/getParams.js
// module id = 2678
// module chunks = 0